import React, { lazy, Suspense } from 'react'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { Spin } from 'antd'
import MainLayout from '@/layouts/MainLayout'
import PrivateRoute from './PrivateRoute'

// lazy import — 초기 번들 크기 최소화
const LoginPage            = lazy(() => import('@/features/auth/LoginPage'))
const DataManagementPage   = lazy(() => import('@/features/data/DataManagementPage'))
const BatchPage            = lazy(() => import('@/features/data/BatchPage'))
const GameTransferPage     = lazy(() => import('@/features/gameManager/GameTransferPage'))
const NotFoundPage         = lazy(() => import('@/features/common/NotFoundPage'))
const UnauthorizedPage     = lazy(() => import('@/features/common/UnauthorizedPage'))

const Loading = () => (
  <div style={{ display: 'flex', justifyContent: 'center', marginTop: 80 }}>
    <Spin size="large" />
  </div>
)

const AppRouter: React.FC = () => (
  <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
    <Suspense fallback={<Loading />}>
      <Routes>
        {/* 공개 라우트 */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/not-available" element={<div style={{ padding: 40 }}>이 도메인에서 사용할 수 없는 기능입니다.</div>} />
        <Route path="/unauthorized"  element={<UnauthorizedPage />} />

        {/* 인증 필요 라우트 */}
        <Route
          element={
            <PrivateRoute>
              <MainLayout />
            </PrivateRoute>
          }
        >
          <Route index element={<Navigate to="/game-manager" replace />} />

          {/* 배치 작업 — 최고관리자(레벨 0)만 */}
          <Route
            path="/batch"
            element={
              <PrivateRoute maxUserLevel={0} requiredModule="config">
                <BatchPage />
              </PrivateRoute>
            }
          />

          {/* 경기 데이터 관리(시스템간 복사/마이그레이션) — 레벨 1 이하 */}
          <Route
            path="/game-manager"
            element={
              <PrivateRoute maxUserLevel={1}>
                <GameTransferPage />
              </PrivateRoute>
            }
          />

          {/* 데이터 관리 — 최고관리자(레벨 0)만 */}
          <Route
            path="/data"
            element={
              <PrivateRoute maxUserLevel={0}>
                <DataManagementPage />
              </PrivateRoute>
            }
          />
        </Route>

        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Suspense>
  </BrowserRouter>
)

export default AppRouter
